import React, { useState } from 'react'
import { Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CenteredLayout } from './shared/CenteredLayout'
import Certificates from '../components/authenticationConfiguration/Certificates'
import SSO from '../components/authenticationConfiguration/SSO'
import ClientApi from '../components/authenticationConfiguration/ClientApi'
import { ContentTitle } from '../components/shared/ContentTitle'

const useStyles = makeStyles(() => ({
    tabs: {
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        marginBottom: '10px',
    },
    bodySection: {
        marginBottom: '30px',
    },
}))

export function AuthenticationConfigurationPage() {
    const classes = useStyles()
    const tabValues = {
        CERTIFICATES: 0,
        SSO: 1,
        CLIENT_API: 2,
    }

    const [tabValue, setTabValue] = useState(tabValues.PLACEHOLDER)

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const TabView = () => {
        switch (tabValue) {
            case tabValues.CERTIFICATES:
                return <Certificates />
            case tabValues.SSO:
                return <SSO />
            case tabValues.CLIENT_API:
                return <ClientApi />
            default:
                return <Certificates />
        }
    }

    return (
        <CenteredLayout>
            <ContentTitle pageTitle={'Authentication'} />

            <div
                style={{ justifyContent: 'center' }}
                className={classes.topBarSection}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor='secondary'
                    textColor='secondary'
                    variant='fullWidth'
                    className={classes.tabs}>
                    <Tab label='Certificates' />
                    <Tab label='SSO' />
                    <Tab label='Client API' />
                </Tabs>
            </div>
            <div className={classes.bodySection}>
                <TabView />
            </div>
        </CenteredLayout>
    )
}
